import { PreferencesConfigService } from './preferences-config.service';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AllViewItem, PreferenceDetails, PreferencesViewData, ViewDetail } from './models/preferences.model';
import { APIResponse, DataContextService } from '../datacontext.service';
import { map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RoutesConfig } from '../../configs/routes.config';

export enum PreferencesStorageKeys {
  SelectedView = 'SelectedView',
  FavoriteView = 'FavoriteView',
  SelectedViewId='SelectedViewId'
}

@Injectable()
export class PreferencesCurrentViewService {
  currentView$: ReplaySubject<PreferencesViewData> = new ReplaySubject(1);
  viewChanged$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private preferencesConfigService: PreferencesConfigService, private dataContextService: DataContextService, private router: Router) { }

  // @todo: can't get actual value without cleaning local storage
  setupCurrentView(): void {
    const selectedView = JSON.parse(this.dataContextService.fetchFromLocalStorage(PreferencesStorageKeys.SelectedViewId));
    if (selectedView) {
      this.getCurrentView(selectedView.selectedViewId).subscribe((res: PreferenceDetails) => this.currentView$.next(this.preferencesConfigService.parseViewDetails(res)));
    }
    else {
      this.getFavoriteView().subscribe((res: PreferenceDetails) => {
        DataContextService.ROWS_PER_PAGE = res.recordsPerPage;
        this.currentView$.next(this.preferencesConfigService.parseViewDetails(res))
      });
    }
  }
  private getFavoriteView(): Observable<PreferenceDetails> {
    return this.dataContextService
      .getData('Views/favourite')
      .pipe(
        map((response: { data: PreferenceDetails }) => {
          const data = response.data;
          const convertedAllViews: AllViewItem[] =
            data.allViews && data.allViews.length > 0
              ? data.allViews.map((allViewItemDTO) => {
                  return {
                    id: allViewItemDTO.id,
                    name: allViewItemDTO.name,
                    isActive: allViewItemDTO.isActive,
                    isFavourite: allViewItemDTO.isFavourite,
                  };
                })
              : [{
                id: data.id,
                name: data.name,
                isActive: data.isActive,
                isFavourite: data.isFavourite
                }];

          const viewDetailDTO = new Array<ViewDetail>();
          data.viewDetails.map((field) => {
            viewDetailDTO.push(field);
          });

          const favoriteView: PreferenceDetails = {
            allViews: convertedAllViews,
            assignedToMe: data.assignedToMe,
            buildings: data.buildings != null ? data.buildings : '',
            // countries: data.countries,
            floors: data.floors,
            id: data.id,
            isActive: data.isActive,
            isFavourite: data.isFavourite,
            name: data.name,
            recordsPerPage: data.recordsPerPage,
            revision: data.revision,
            viewDetails: viewDetailDTO,
          };

          return favoriteView;
        })
      )
  }
  private getCurrentView(id: string): Observable<PreferenceDetails> {
    return this.dataContextService
      .getData('Views/' + id, true, false, true)
      .pipe(
        switchMap((response: APIResponse) => {
          if (response.status === 404) {
            this.dataContextService.removeFromLocalStorage(PreferencesStorageKeys.SelectedViewId);
            return this.dataContextService.getData(`Views/favourite`);
          }
          else
            return of(response);
        }),
        map((response: { data: PreferenceDetails }) => {
          const data = response.data;
          const convertedAllViews: AllViewItem[] =
            data.allViews && data.allViews.length > 0
              ? data.allViews.map((allViewItemDTO) => {
                  return {
                    id: allViewItemDTO.id,
                    name: allViewItemDTO.name,
                    isActive: allViewItemDTO.isActive,
                    isFavourite: allViewItemDTO.isFavourite,
                  };
                })
              : [{
                id: data.id,
                name: data.name,
                isActive: data.isActive,
                isFavourite: data.isFavourite
              }];

          const viewDetailDTO = new Array<ViewDetail>();
          data.viewDetails.map((field) => {
            viewDetailDTO.push(field);
          });

          const favoriteView: PreferenceDetails = {
            allViews: convertedAllViews,
            assignedToMe: data.assignedToMe,
            buildings: data.buildings != null ? data.buildings : '',
            // countries: data.countries,
            floors: data.floors,
            id: data.id,
            isActive: data.isActive,
            isFavourite: data.isFavourite,
            name: data.name,
            recordsPerPage: data.recordsPerPage,
            revision: data.revision,
            viewDetails: viewDetailDTO,
          };

          return favoriteView;
        })
      )
  }

}
